import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import campaignDataReducer from "./common/reducers/campaignDataReducer";
import createCampaignReducer from "./common/reducers/createCampaignReducer";
import userReduer from "./common/reducers/userReduer";

let store;
export default store = configureStore({
  reducer: {
    user: userReduer,
    createCampaign: createCampaignReducer,
    campaign: campaignDataReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
